import { useEffect } from "react";
import {
  ActionBtnContainer,
  ActionBtnU,
  ActionContainer,
} from "./sharedImports";
import { DateRangePicker, FacilitySelect } from "../../form/incident-inputs";

type FallFormProps = {
  formName: string;
  handleSubmit: () => void;
  facilityOptions: any[];
  setFieldValue: any;
  values: any;
  closeFn: () => void;
  isSubmitDisabled: boolean;
  isFetching: boolean;
  bottom: boolean;
  fallFacility?: any;
  startDate?: string;
  endDate?: string;
};

const FallForm = ({
  formName,
  handleSubmit,
  facilityOptions,
  setFieldValue,
  values,
  closeFn,
  isSubmitDisabled,
  isFetching,
  bottom,
  fallFacility = null,
  startDate = "",
  endDate = "",
}: FallFormProps) => {
  useEffect(() => {
    if (fallFacility !== null) setFieldValue("facilityInfo", fallFacility);
    if (startDate.length) setFieldValue("startDate", startDate);
    if (endDate.length) setFieldValue("endDate", endDate);
  }, [fallFacility, startDate, endDate]);

  const checkInputChange = () => {
    return (
      values.facilityInfo !== fallFacility ||
      startDate !== values.startDate ||
      endDate !== values.endDate
    );
  };

  const checkSubmitDisabled = isSubmitDisabled || !checkInputChange();

  return (
    <form name={formName} onSubmit={handleSubmit}>
      <FacilitySelect
        name="facilityInfo"
        placeholder="Select Facility"
        options={facilityOptions}
        isMulti={false}
        onChange={(opt) => setFieldValue("facilityInfo", opt)}
        selected={values.facilityInfo}
      />
      <DateRangePicker
        startDate={values.startDate}
        endDate={values.endDate}
        setFieldValue={setFieldValue}
        limitOneYear={true}
      />
      <ActionContainer>
        <ActionBtnContainer
          className="flex w-1/3"
          data-testid="generate-btn-container"
        >
          <ActionBtnU purple_border onClick={() => closeFn()} type="button">
            Cancel
          </ActionBtnU>
          <ActionBtnU
            purpleBg
            white_color
            type="submit"
            onClick={() => handleSubmit()}
            disabled={checkSubmitDisabled}
          >
            {isFetching ? "Loading" : "Generate"}
          </ActionBtnU>
        </ActionBtnContainer>
      </ActionContainer>
    </form>
  );
};

export default FallForm;
